import React from 'react'
import styled from 'styled-components'
import facebookImage from 'images/common/icon_facebook_circle.svg'
import twitterImage from 'images/common/icon_twitter_circle.svg'
import outboundIcon from 'images/common/outbound_icon_monochrome.svg'
import CrowdWorksCompanyName from '../CrowdWorksCompanyName'

const Footer = styled.footer`
  background-color: ${props => props.theme.members.colors.white};
  color: ${props => props.theme.members.colors.silver._100};
  font-size: 0.75rem;
  line-height: 1.625;
  margin: 0 1rem;
  padding-bottom: 1.75rem;

  @media ${props => props.theme.media.md} {
    margin: 0;
    padding: 2rem 1rem 0 1rem;
  }

  @media ${props => props.theme.media.lg} {
    margin: 0;
    padding: 1rem 0;
  }
`

const FooterWrapper = styled.div`
  margin: 0 auto;
  padding: 2rem 0 1.75rem;

  @media ${props => props.theme.media.md} {
    margin-bottom: 1.5rem;
    padding: 0 15px;
    width: calc(100% - 80px);
  }
`

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  @media ${props => props.theme.media.md} {
    row-gap: .5rem;
  }
`

const FooterList = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style-type: none;
  margin: 0;
  padding: 0.625rem 0;

  @media ${props => props.theme.media.md} {
    padding: 0;
  }

  ${props => (props.isColumn && `
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin-bottom: 1.5rem;
    padding: 0;
  `)}
`

const FooterListItem = styled.li`
  margin-bottom: 0.5rem;
  &:first-child {
    margin-right: 1rem;
  }

  @media ${props => props.theme.media.md} {
    margin-right: 2.5rem;
    &:last-child {
      margin-right: 0;
    }
  }
`

const FooterListLink = styled.a`
  color: ${props => props.theme.members.colors.black._100};
  font-size: 0.875rem;
  line-height: 1.25rem;

  &:hover {
    color: inherit;
    text-decoration: none;
    opacity: 0.7;
  }

  &.-outbound-link::after {
    display: inline-block;
    content: "";
    width: 0.75rem;
    height: 0.75rem;
    margin-left: 0.5rem;
    background-image: url(${outboundIcon});
    background-repeat: no-repeat;
  }
`

const FooterListItemsSns: React.FC = () => {
  return (
    <>
      <FooterListItem>
        <FooterListLink href="https://www.facebook.com/crowdtech.jp/">
          <img src={facebookImage} alt="facebook"/>
        </FooterListLink>
      </FooterListItem>
      <FooterListItem>
        <FooterListLink href="https://twitter.com/CrowdWorks_tech">
          <img src={twitterImage} alt="twitter"/>
        </FooterListLink>
      </FooterListItem>
    </>
  )
}

const FooterListItemsCopyright: React.FC = () => {
  const blogUrl = 'https://crowdworks.jp/p-journal/'
  const privacyUrl = 'https://crowdworks.co.jp/privacy_policy'

  return (
    <>
      <FooterListItem>
        <FooterListLink href={blogUrl} target='_blank' className="-outbound-link">パラレルジャーナル</FooterListLink>
      </FooterListItem>
      <FooterListItem><FooterListLink href="/terms" data-cy='footer-link-terms'>利用規約</FooterListLink></FooterListItem>
      <FooterListItem><FooterListLink href={privacyUrl}>個人情報保護方針</FooterListLink></FooterListItem>
      <FooterListItem><FooterListLink href="/sitemap">サイトマップ</FooterListLink></FooterListItem>
    </>
  )
}

const FooterListMobile: React.FC = () => {
  return (
    <>
      <FooterList><FooterListItemsSns /></FooterList>
      <FooterList isColumn><FooterListItemsCopyright /></FooterList>
    </>
  )
}

const FooterListPc: React.FC = () => {
  return (
    <FooterList><FooterListItemsSns /><FooterListItemsCopyright /></FooterList>
  )
}

export const StyledFooter: React.FC = (props) => {
  const isMobile = navigator.userAgent.match(/iPhone|Android.+Mobile|iPad/)

  return (
    <Footer>
      <FooterWrapper>
        <Row>
          { isMobile && <FooterListMobile /> }
          <div>copyright (c) CrowdWorks Inc. all rights reserved.<br/>運営会社：<CrowdWorksCompanyName /></div>
          { !isMobile && <FooterListPc />}
        </Row>
      </FooterWrapper>
    </Footer>
  )
}
